import { render, staticRenderFns } from "./TurnoAjustes.vue?vue&type=template&id=565841bf&"
import script from "./TurnoAjustes.vue?vue&type=script&lang=js&"
export * from "./TurnoAjustes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports